Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var vIi40 = f2102(require("./krunkScriptConfig.js"));
function f2102(p16526) {
  if (p16526 && p16526.__esModule) {
    return p16526;
  } else {
    return {
      default: p16526
    };
  }
}
var vO424 = {
  prefix: {
    regexStr: `${vIi40.default.prefix}_(\\w+)`,
    add: function (p16527) {
      return `${vIi40.default.prefix}_${p16527}`;
    },
    remove: function (p16528) {
      return p16528.replace(new RegExp(vO424.prefix.regexStr, "g"), "$1");
    },
    has: function (p16529) {
      return p16529.startsWith(`${vIi40.default.prefix}_`);
    }
  },
  wildcardToRegex: function (p16530) {
    return new RegExp(p16530.replace(/\./g, "\\.").replace(/\*/g, "(.+)"), "g");
  },
  listItems: function (iÎìïìíî = [], iÏîîííì = ",") {
    if (iÎìïìíî.length > 1) {
      return `${iÎìïìíî.slice(0, -1).join(", ")} ${iÏîîííì} ${iÎìïìíî[iÎìïìíî.length - 1]}`;
    } else {
      return iÎìïìíî.join(", ");
    }
  },
  escStr: function (p16531) {
    return `"${p16531}"`;
  }
};
var vVO424 = vO424;
exports.default = vVO424;